import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "update-payment-method",
  "use": "update-payment-method-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"update-payment-method\"><path fill-rule=\"evenodd\" d=\"M12 12.5c-2.2 0-4 1.8-4 4 0 .8.2 1.6.7 2.2l1.1-1.1c-.2-.3-.3-.7-.3-1.1 0-1.4 1.1-2.5 2.5-2.5v1.5l2.2-2.2L12 11v1.5Zm0 9.5v-1.5c2.2 0 4-1.8 4-4 0-.8-.2-1.6-.7-2.2l-1.1 1.1c.2.3.3.7.3 1.1 0 1.4-1.1 2.5-2.5 2.5v-1.5l-2.2 2.2L12 22ZM4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-2v-2h2v-6H4v6h2v2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2Zm0 4h16V4H4v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol